export default __webpack_public_path__ + "static/media/back_icon.0bd96dca.svg";